import { render } from "./StockMovements.vue?vue&type=template&id=66eb1497&scoped=true"
import script from "./StockMovements.vue?vue&type=script&lang=js"
export * from "./StockMovements.vue?vue&type=script&lang=js"

import "./StockMovements.vue?vue&type=style&index=0&id=66eb1497&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66eb1497"]])

export default __exports__